export const FORGOTTEN_PASSWORD_BEGIN = "FORGOTTEN_PASSWORD_BEGIN";
export const forgottenPasswordBegin = (email) => ({
  type: FORGOTTEN_PASSWORD_BEGIN,
  email,
});

export const FORGOTTEN_PASSWORD_FAILURE = "FORGOTTEN_PASSWORD_FAILURE";
export const forgottenPasswordFailure = () => ({
  type: FORGOTTEN_PASSWORD_FAILURE,
});

export const FORGOTTEN_PASSWORD_SUCCESS = "FORGOTTEN_PASSWORD_SUCCESS";
export const forgottenPasswordSuccess = () => ({
  type: FORGOTTEN_PASSWORD_SUCCESS,
});

export const FORGOTTEN_PASSWORD_RESET_BEGIN = "FORGOTTEN_PASSWORD_RESET_BEGIN";
export const forgottenPasswordResetBegin = (
  email,
  code,
  password,
  securityAnswer
) => ({
  type: FORGOTTEN_PASSWORD_RESET_BEGIN,
  email,
  code,
  password,
  securityAnswer,
});

export const FORGOTTEN_PASSWORD_RESET_FAILURE = "FORGOTTEN_PASSWORD_FAILURE";
export const forgottenPasswordResetFailure = () => ({
  type: FORGOTTEN_PASSWORD_RESET_FAILURE,
});

export const FORGOTTEN_PASSWORD_RESET_SUCCESS = "FORGOTTEN_PASSWORD_SUCCESS";
export const forgottenPasswordResetSuccess = () => ({
  type: FORGOTTEN_PASSWORD_RESET_SUCCESS,
});
